<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
<!--___________Form_____________ -->
    <v-card>
      <v-card-title class="pb-0">
        <span class="headline">Loan Re-Schedule</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation class="mt-0">
        <v-card-text>
          <v-container grid-list-md class="py-0">
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'installment_date', fieldValue:formSchema.installment_date, label:'New Re-Schedule Date *', required:'1', minVal:formSchema.re_schedule_date,currentDate:'1'}"
                @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md6>
               <v-autocomplete
                label="Loan Number *"
                item-text="loan_no"
                item-value="id"
                v-model="formSchema.loan_id"
                :items="loanNoList"
                :rules="[v => !!v || 'Loan number is required !']"
                required
                @change="getClientName(formSchema.loan_id)"
              ></v-autocomplete>
              </v-flex>
              
              <v-flex xs12 sm6 md6 >
                <v-text-field
                label="Sub-Project Name"
                v-model="formSchema.sub_project_name"
                :rules="[v => !!v || 'Sub-project name is required !']"
                required
                readonly
              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6 >
                <v-text-field
                label="Client Name *"
                v-model="formSchema.client_name"
                :rules="[v => !!v || 'Client name is required !']"
                required
                readonly
              ></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 md6 offset-md3>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click.native="searchInfo" :disabled="!valid">
                    <v-icon>search</v-icon>
                    Search
                  </v-btn>
                </v-card-actions>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <!-- _____________/Form_____________ -->

  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import Axios from "axios";
import DatePicker from "../../global/date_picker";

export default {
  components: {
   DatePicker 
  },

  data: () => ({
    valid: true,
    projectList:[],
    loanNoList:[],
    leaveTypeModal: false,
    detailObject:'',

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    formSchema: {
      id: 0,
      project_name_short: "",
      loan_id: "",
      client_name:"",
      sub_project_name:"",
      installment_date:"",
      interest_rate:0.00,
    },
    
  }),

  created(){
    this.$store.commit('UNSET_COMMON_DATA');
    commonService.getAllData("get-dis-dropdown-data").then(res => {        
        this.loanNoList = res.loanNoList;
    });
  },

  methods: {

    searchInfo()
    {    
      this.$store.commit('UNSET_COMMON_DATA');

       if (this.$refs.form.validate()) {  
        let formSchema = this.formSchema;
        formSchema.installment_date = this.changeFormateYMD(formSchema.installment_date);
        commonService.dataByMulParameters(formSchema,'get-loan-re-schedule').then(res => {
          if(res.status == 0)
          {
            this.SnackbarVal.color = "error"         
            this.SnackbarVal.message = res.message;
            this.SnackbarVal.snackbar = true;
            return 0;
          }
          if(res.old_opening_principal < 1)
          {
            this.SnackbarVal.color = "error"         
            this.SnackbarVal.message = "Reschedule list is empty";
            this.SnackbarVal.snackbar = true;
            return 0;
          }

          let data = res.data;
          
          
          data['loan_id'] = data.id;
          data['available_amount'] = (data.loan_amount - data.disbursement_amount);
          data['voucher_number'] = res.voucher_number;  
          data['disbursement_accountInfo'] = res.disbursement_accountInfo; 
          data['old_opening_principal'] = res.old_opening_principal;
          data['old_paid_installment_number'] = res.old_paid_installment_number ;
          data['new_re_schedule_date'] = this.changeFormateYMD(this.formSchema.installment_date);
          data['principal'] = res.principal;
          data['interest'] = res.interest;
          data['total_Days'] = res.total_Days;
          data['extra_interest'] = res.extra_interest;
          data['outstanding'] = res.outstanding;
          data['lastInstallment_date'] = res.lastInstallment_date;
          data['unpaid_installment'] = res.unpaid_installment;
          data['sum_installment'] = res.sum_installment;
          data['partialPayData'] = res.partialPayData;

          //console.log('data==', data);
          //return 0;
          this.$store.commit('SET_COMMON_DATA',data); 
          this.$router.push("/on-lending/loan-reschedule"); 
        });
      }
    },

    getClientName(loanId){      
      let Loan = this.loanNoList.filter(function(a) {
          return a.id == loanId;
        })[0];
      //console.log('this.Loan', Loan);

      this.formSchema.client_name  = Loan.client_name;
      this.formSchema.sub_project_name  = Loan.sub_project_name;
      this.formSchema.interest_rate = Loan.interest_rate;
    },

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },
   
    close(res) {
      this.leaveTypeModal = false;      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/lending/loanReSchedule/search_form.vue